import React from 'react';

const Title = ({ children }: { children: React.ReactNode }) => {
  return <h2 className="text-center mb-5">{children}</h2>;
};

export { Title };
